<template>

  <div>
    <nav
      class="list-group list-group-flush">
      <router-link
        v-for="(profile, index) in profiles.docs"
        :key="index"
        class="list-group-item list-group-item-action"
        :class="{ 'list-group-item-secondary': profile._id === profileId }"
        :to="goToProfile(profile._id)">
        <div>
          <div class="d-flex">
            <div
              v-if="profile.photo_media_url"
              class="avatar mr-3">
              <img
                :src="profile.photo_media_url"
                :alt="profile.name"
                class="img-fluid rounded-circle mb-3"
                style="max-width: 60px;"
              />
            </div>
            <div class="flex-grow-1">
              <div>
                <h4 class="mb-1">{{ profile.name }}</h4>
                <p class="mb-1 text-muted">{{ profile.position }}</p>
                <small class="text-muted">{{ profile.location }}</small>
              </div>
              <p class="mt-3 mb-2">{{ profile.short_description }}</p>
            </div>
          </div>
        </div>
      </router-link>
    </nav>
  </div>

</template>

<script>
export default {
  name: 'JobSeeker',
  components: {
  },
  props: {
    profiles: {
      type: Object,
      default: () => ({})
    },
    job: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
    }
  },
  computed: {
    profileId () {
      return this.$route.params.profile_id
    }
  },
  created () {
  },
  methods: {
    // get current route and add param profile_id
    goToProfile (id) {
      return `/job/${this.job._id}/seeker/${id}`
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeekerList.vue